import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { InspectionCornSchema } from '../base.js';
import { DocumentWithSignedUrlSchema } from '../entities/document.js';
import { LabelFilterSchema } from '../util.js';
export const GetInspectionDocumentsApiSchema = {
    params: z.object({
        entityId: z.union([ClaimV2CornSchema, JobCornSchema]),
        inspectionId: InspectionCornSchema,
    }),
    query: LabelFilterSchema,
    response: z.object({
        documents: DocumentWithSignedUrlSchema.array(),
    }),
};
export const GetInspectionDocumentsRequestSchema = GetInspectionDocumentsApiSchema.params.merge(GetInspectionDocumentsApiSchema.query);
